import gql from 'graphql-tag'

export const GET_SHIFT_VIEW = gql`
  query GetShiftView($filters: JSONObject!) {
    t7ShiftChangeView(filters: $filters) {
      data
    }
  }
`
